// Takes a year and a quarter and gives you back the last day in that quarter

import { addQuarters, format, lastDayOfQuarter, parse } from 'date-fns';

export default function lastDateInQuarter(quarter, year) {
  return format(lastDayOfQuarter(addQuarters(parse(`${year}-01-01`), quarter - 1)), 'YYYY-MM-DD');
}
